import { Alert } from 'roo-ui/components';

const RequestAlert = (props) => (
  <Alert variant="info" backgroundColor="lightOrange" mb={0} {...props}>
    <b>Please note</b>, your dates will not be updated straight away. We will contact you to finalise this request.
  </Alert>
);

export default RequestAlert;
